import React from 'react';
import logo from '../../assets/svg/logo.svg';

const Loader: React.FC = () => {
  return (
    <div className="Loader">
      <div className="overlay-container">
        <div className="loader">
          <img src={logo} alt="loader-logo" />
        </div>
      </div>
    </div>
  );
};

export default Loader;
